import idx from "idx"

function transform(data) {
  const content = idx(data, _ => _.content)
  // if we need to go beyond the 50000 character limit for long text field, there will be 'contentMore'
  const contentMore = idx(data, _ => _.contentMore)
  // if we have markdown content
  let md = idx(content, _ => _.childMarkdownRemark.html)
  md = contentMore ? md + idx(contentMore, _ => _.childMarkdownRemark.html) : md
  // else ... (e.g. like quotes)
  let copy = idx(content, _ => _.content)
  copy = contentMore ? copy + idx(contentMore, _ => _.content) : copy
  return {
    data: md || copy
  }
}

export default {
  transform
}
